import { EPayoutType } from "@rentiohq/shared-frontend/dist/types/payment.types";
import {
  ERentDepositStatus,
  IRentDeposit,
} from "@rentiohq/shared-frontend/dist/types/rentDeposit.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { ts } from "../../../../services";

/**
 * In these statuses, the rental deposit can be cancelled
 * "NEW",
 * "OPEN_TO_SIGN",
 * "PAYING_IN_PARTIALLY_SIGNED",
 * "PAID_IN_PARTIALLY_SIGNED",
 * "PAYING_IN"
 */

export const canCancelRentalDeposit = (rentDeposit: IRentDeposit) => {
  const cancellable = [
    ERentDepositStatus.New,
    ERentDepositStatus.OpenToSign,
    ERentDepositStatus.PayingInPartiallySigned,
    ERentDepositStatus.PaidInPartiallySigned,
    ERentDepositStatus.PayingIn,
  ];

  return cancellable.includes(rentDeposit.status);
};

/**
 * In these statuses, the release of the rental deposit can be cancelled
 * "RELEASE_NEW",
 * "WAITING_FOR_IBAN",
 * "RELEASE_TO_SIGN",
 * "WAITING_FOR_VALIDATIONS
 */
export const canCancelRentalDepositRelease = (rentDeposit: IRentDeposit) => {
  const releaseCancellable = [
    ERentDepositStatus.ReleaseNew,
    ERentDepositStatus.WaitingForIBAN,
    ERentDepositStatus.WaitingForValidations,
    ERentDepositStatus.ReleaseToSign,
    ERentDepositStatus.ManualVerification,
    ERentDepositStatus.ManualVerificationJudicial,
  ];
  return releaseCancellable.includes(rentDeposit.status);
};

const getPaymentMethodFromRentDepositPo = (rentDeposit: IRentDeposit) => {
  if (!rentDeposit.paymentOrder) {
    return;
  }

  if (!rentDeposit.paymentOrder.paymentRequests?.length) {
    return;
  }

  const paidPayout = rentDeposit.paymentOrder.paymentRequests.find(
    paymentRequest => paymentRequest.payoutType === EPayoutType.Charge,
  );

  return paidPayout?.paymentMethod;
};

export const getRentDepositStatus = (rentDeposit: IRentDeposit) => {
  if (rentDeposit.status === ERentDepositStatus.BanqupPendingPayment) {
    const paymentMethod = getPaymentMethodFromRentDepositPo(rentDeposit);

    return getLocalizedText(
      `follow_up.rent_deposits.filter.status.${rentDeposit.status.toLowerCase()}.label`,
      {
        paymentMethod: paymentMethod
          ? getLocalizedText(`payment_request.method.${paymentMethod}`)
          : getLocalizedText("system.unknown"),
      },
    );
  }

  return ts.followUpRentDepositsFilterStatusLabel({
    extra: { key: rentDeposit.status },
  });
};
